import {SessionPricingFormFields} from "../../session/pricing";

export function BundleSessionPricingFormFields() {
  return <SessionPricingFormFields currenciesFieldId="bundlePrice" />;
}
